import { render, staticRenderFns } from "./YoutubeComments.vue?vue&type=template&id=9435e42a&scoped=true&"
import script from "./YoutubeComments.vue?vue&type=script&lang=js&"
export * from "./YoutubeComments.vue?vue&type=script&lang=js&"
import style0 from "./YoutubeComments.vue?vue&type=style&index=0&id=9435e42a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9435e42a",
  null
  
)

export default component.exports